import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { ProductDetailsPage } from '../components/product-details';
import { CartData } from '../../../providers/cart-data';
import { FirebaseData } from '../../../providers/firebase-data';
import { Utils } from '../../../providers/utils';
import { CartPage } from '../../../pages/cart/cart';
import _ from 'lodash';


@Component({
  selector: 'page-store-details',
  templateUrl: "store-details.html"
})

export class StoreDetailsPage {

  public store;
  public storeId;
  public products =[];
  public productGrid;
  public isShowingSearchResults: boolean = false;
  public cartItems: any=[];
  public cartTotal: number=0;
  public currentUser: any;
  public isLoading: boolean = true;

  constructor(
    private params: NavParams, 
    private nav: NavController, 
    private firebaseData: FirebaseData,
    private cartData: CartData,
    //private userData: UserData,
    private events: Events
    ) {
    this.store = this.params.get("store");
    this.storeId = this.params.get("storeId");
  }
  ionViewDidEnter() {
    let self = this;
    
    if(self.store){
      self.loadStoreProducts();
    } else if(self.storeId){
      self.firebaseData.get('stores/' + self.storeId).subscribe(store=>{
        if(store){
          self.store = {key: self.storeId, value:store};
          self.loadStoreProducts();
          self.getCartTotal();
        }
      });
    }
    
  }

  private loadStoreProducts(){
    //let self = this;
    //this.userData.hasLoggedIn().subscribe((isLoggedIn) => {
        //console.log(isLoggedIn);        
        //if(isLoggedIn){
            //self.userData.getUser().subscribe((user) => {
                //self.currentUser = user;
                //self.cartData.getAllItems(self.currentUser.uid).subscribe(items => {
                  //self.cartItems = items;
                  //self.getCartTotal();
                //});
                //self.getProducts();
            //});
        //}else{
            //this.nav.push(AccountPage);
        //}
    //});
  }

  private getCartTotal(){
    let self = this;
    self.cartTotal = 0;
    _.each(self.cartItems, function(item){
      self.cartTotal += item.value.value.cartCount;
    });
  }


  //create product grid
  private getProducts(){
    let self = this;
    self.isLoading = true;
    this.firebaseData.get('products/'+this.store.key).subscribe(data=>{
      self.products = Utils.toArray(data);
      self.processProducts();
      self.productGrid = _.chunk(this.products, 2);
      self.isLoading = false;
    }); 
  }

  private processProducts(){
    let self = this;
    _.each(self.products, function(prod){
      if(!prod.value.cartCount){ prod.value.cartCount = 0;}
      _.each(self.cartItems, function(item){
        if(prod.key==item.value.key){
          prod.value.cartCount = item.value.value.cartCount;
          prod.value.cartItemId = item.key;
        }
      });
    });
  }

  //search bar function
  public getItems(ev) {
      
      // set val to the value of the ev target
      var val = ev.target.value;

      // if the value is an empty string don't filter the items
      if (val && val.trim() != '') {
          this.products = this.products.filter((_product) => {
              return (_product.value.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
          })
      }
  }

  //open shop-detail page
  public viewProductDetails(product) {
    this.nav.push(ProductDetailsPage, {product: product});
  }

  public onSearchBarFocus (ev){
    this.isShowingSearchResults = true;
  }

  public onSearchBarBlur (ev){
    this.isShowingSearchResults = false;
    this.getProducts();
  }

  public updateCart(product, quantity){

    product.value.cartCount += quantity;
    if(product.value.cartCount < 0){
      product.value.cartCount=0;
    }

    var self = this;
    if(product.value.cartCount == 0){
      self.cartData.deleteItem(self.currentUser.uid, product.value.cartItemId).subscribe(isDeleted=>{
        console.log("Item deleted");
      })
    }else {
      if(!product.value.cartItemId){
        self.cartData.addItem(self.currentUser.uid, product).subscribe(newKey =>{
          product.value.cartItemId = newKey;
          console.log("Add New Item", newKey);
        });
      }else{
        self.cartData.updateItem(self.currentUser.uid, product).subscribe(updated =>{
          console.log("Update Cart:", updated);
        });
      }
    }
  }

  public loadCart(){
    this.nav.push(CartPage, {cartItems: this.cartItems});
  }
}






// WEBPACK FOOTER //
// ./src/pages/orders/components/store-details.ts